import { ApiEndpoints } from "../constants/apiEndpoints";
import { jigenpassApi } from "../utils/apiClient";

class NotificationsService {
  async getUserNotifications(userId, params) {
    return await jigenpassApi.get(
      `${ApiEndpoints.NOTIFICATIONS}/users/${userId}`,
      {
        params,
      },
    );
  }

  async getMyNotifications(params) {
    return await jigenpassApi.get(ApiEndpoints.NOTIFICATIONS, { params });
  }

  async sendOrderNotification(userId, data) {
    return await jigenpassApi.post(
      `${ApiEndpoints.NOTIFICATIONS}/users/${userId}/order`,
      data,
    );
  }

  async sendPaymentNotification(userId, data) {
    return await jigenpassApi.post(
      `${ApiEndpoints.NOTIFICATIONS}/users/${userId}/payment`,
      data,
    );
  }

  async getUserNotificationPreferences(userId) {
    return await jigenpassApi.get(
      `${ApiEndpoints.NOTIFICATIONS}/users/${userId}/preferences`,
    );
  }

  async sendBroadcast(data) {
    return await jigenpassApi.post(
      `${ApiEndpoints.NOTIFICATIONS}/broadcast`,
      data,
    );
  }

  async markAsRead(notificationId) {
    return await jigenpassApi.post(
      `${ApiEndpoints.NOTIFICATIONS}/${notificationId}/read`,
    );
  }

  async markAllAsRead() {
    return await jigenpassApi.post(`${ApiEndpoints.NOTIFICATIONS}/read-all`);
  }

  async archiveNotification(notificationId) {
    return await jigenpassApi.post(
      `${ApiEndpoints.NOTIFICATIONS}/${notificationId}/archive`,
    );
  }

  async deleteNotification(notificationId) {
    return await jigenpassApi.delete(
      `${ApiEndpoints.NOTIFICATIONS}/${notificationId}`,
    );
  }
}

const notificationsService = new NotificationsService();
export default notificationsService;
export { notificationsService };
